import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";

import pdf1 from "../pamphlets/APPROVED-What_is_an_Orthodontist_Flyer-NEW-LOGO-2011.pdf";
import pdf2 from "../pamphlets/Problems_Growing_Children-12-l.pdf";
import pdf3 from "../pamphlets/Problems-Watch-7yr-olds-09-l.pdf";
import pdf4 from "../pamphlets/Problems-to-Watch-Adults-r-l.pdf";
import pdf5 from "../pamphlets/AAO_Dental_Trauma_Flyer_FINAL-NEW-LOGO-2011.pdf";

const pamphlets = [
  { title: "What is an Orthodontists?", file: pdf1 },
  {
    title:
      "The Right Time for an Orthodontic Check-Up: No Later than Age 7",
    file: pdf2
  },
  {
    title:
      "American Association of Orthodontists Recommendation For Orthodontic Check-Ups No Later than Age 7",
    file: pdf3
  },
  {
    title:
      "The American Association of Orthodontists Recommends Treatment for Adults, When Appropriate, in Conjunction with Regular Dental Care",
    file: pdf4
  },
  {
    title: "Prevent Accidents: But Know What To Do If One Occurs",
    file: pdf5
  }
];

export const Pamphlet = () => {
  return (
    <Container fluid className="content">
      <Row>
        <Col className="title">
          <h1>Pamphlets & Information</h1>
        </Col>
      </Row>
      <Row>
        <Col sm="1" md="2" lg="3" />
        <Col sm="10" md="8" lg="6">
          <ul style={{ listStyle: "none" }}>
            {pamphlets.map(pamphlet => (
              <li key={pamphlet.title} className="pamphlet">
                <a
                  href={pamphlet.file}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faBook} /> {pamphlet.title}
                </a>
              </li>
            ))}
          </ul>
        </Col>
        <Col sm="1" md="2" lg="3" />
      </Row>
    </Container>
  );
};
